import { WIDGET } from "@model/components/componentMeta.model";
import texthelper from '@helpers/text.helper'

const createWidgetText = (text = '<p class="ql-align-center"><span class="ql-font-paragraph1">sample data</span></p>') => {

  const randomkey = `${WIDGET.prefixKey}${Math.random()
    .toString(36)
    .substring(4)}`;
  const key = `${WIDGET.prefixKey}${randomkey.substring(
    randomkey.length - 4,
    randomkey.length
  )}`;
  const mostFontSizeDesktop = 16;
  const alignX = 'start';

  // const a = mostFontSizeDesktop > 25 ? 3 : 1

  return {
    key,
    object: {
      [key]: {
        type: `SYSTEM_WIDGET_TEXT`,
        id: key,
        version: '1',
        properties: {
          isSystem: true,
        },
        style: {
          alignX: alignX,
          marginTop: 10,
          marginBottom: 10,
          mostFontSizeDesktop: mostFontSizeDesktop,
        },
        styleMobile: {
          alignX: alignX,
          marginTop: 10,
          marginBottom: 10,
          mostFontSizeMobile: texthelper.responsiveFontSize(mostFontSizeDesktop),
          alignChanged: false,
        },
        styleTablet: {
          alignX: alignX,
          marginTop: 10,
          marginBottom: 10,
          mostFontSizeTablet: mostFontSizeDesktop,
          alignChanged: false,
        },
        data: text,
        dataMobile: text,
        dataTablet: text,
      },
    },
  };
};

export {
  createWidgetText,
};
export default {
  createWidgetText,
};
